<template>
  <b-dropdown left menu-class="pb-0" variant="link" no-caret>
    <template #button-content>
      <a class="text-primary">
        <span>{{ $t('by_doctors') }}</span>
        <ArrowSvg class="ml-2"/>
        <!--        <span class="notification-bubble" v-if="selected.length > 0">{{ selected.length }}</span>-->
      </a>
    </template>
    <div class="pt-3">
      <div v-for="d in doctors"
           :key="`doctor-filter-opt-${d.id}`"
           class="px-3"
           style="width: 300px;">
        <CheckboxGroup :label="d.full_name"
                       :checkboxvalue="d.id"
                       :fid="`checkbox-w-${d.id}`"
                       v-model="selected"/>
      </div>
      <a class="mt-3 btn-themed w-100 d-block text-center btn-themed-squared" @click="apply">{{ $t('apply') }}</a>
    </div>
  </b-dropdown>
</template>

<script>

import { mapState } from "vuex"
import CheckboxGroup from "@/components/form/CheckboxGroup"
import ArrowSvg from '@/assets/svg-vue/general/arrow_down.svg'

export default {
  name: "PatientsHeaderDoctorsFilter",
  components: {
    CheckboxGroup,
    ArrowSvg
  },
  methods: {
    parseRoute() {
      if(this.$route.query.filters) {
        let js = JSON.parse(this.$route.query.filters)
        if(js.doctor_id) {
          let f = js.doctor_id
          if(f.type === 'contains') {
            this.selected = f.condition
          } else {
            if(f.type === 'equals') {
              this.selected = [f.condition]
            }
          }
        } else {
          this.selected = []
        }
      }
      this.$nextTick(() => {
        this.watcher = true
      })
    },
    apply() {
      if(!this.watcher) { return }
      let data = {}
      let arr = []
      for(const v in this.selected) {
        arr.push(this.selected[v])
      }
      data['doctor_id'] = {
        id:         'doctor_id',
        condition:  arr,
        type:       'contains',
      }
      if(arr.length === 0) { data = {} }
      this.$store.commit('setFilters', data)
      let query = arr.length > 0 ? { filters: JSON.stringify(data) } : {}
      if(query.filters && this.$route.query && this.$route.query.filters && query.filters == this.$route.query.filters) {
        return
      }
      this.$router.push({ path: this.$route.path, query: query }).catch(()=>{})
    }
  },
  computed: {
    ...mapState({
      doctors: state => state.auth.doctors,
    }),
  },
  data() {
    return {
      selected: [],
      watcher: false
    }
  },
  mounted() {
    this.parseRoute()
  },

  watch: {
    $route() {
      if(this.watcher) {
        this.parseRoute()
      }
    },
    // selected() {
    //
    // }
  }
}
</script>

<style scoped lang="scss">
.notification-bubble {
  right: 14px;
}
.btn-themed {
  border-top-left-radius:  0;
  border-top-right-radius:  0;
}
</style>
